import { object, mixed } from 'yup';
import { addressSchema } from '../../../address/address-fields/address-schema';
import { COMPANY, EMAIL } from '../../../address/constants';
import { ORIGIN_ADDRESS, RETURN_ADDRESS } from './constants';
import { generateAddressFormattedMessage } from './messages';

// TODO: SPD-11422 - I don't think this schema extension is necessary
// i.e. addressSchema COMPANY is not explicitly required
const shipFromAddressSchema = addressSchema.shape({
  [COMPANY]: addressSchema.fields[COMPANY].nullable(),
  [EMAIL]: addressSchema.fields[EMAIL].nullable(),
});

export const shipFromDropdownSchema = object({
  [ORIGIN_ADDRESS]: mixed().test(`${ORIGIN_ADDRESS} validation`, generateAddressFormattedMessage(ORIGIN_ADDRESS), (value) =>
    shipFromAddressSchema.isValidSync(value),
  ),
  [RETURN_ADDRESS]: mixed().test(`${RETURN_ADDRESS} validation`, generateAddressFormattedMessage(RETURN_ADDRESS), (value) =>
    shipFromAddressSchema.isValidSync(value),
  ),
});
